import classNames from "classnames";
import { FC, ReactNode } from "react";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  children: ReactNode;
  isPaused: boolean;
};

const MetroWrapper: FC<Props> = ({ children, className, isPaused }) => {
  return (
    <div
      className={classNames(
        styles.metroWrapper,
        { [styles.paused]: isPaused },
        className
      )}
    >
      {children}
    </div>
  );
};

export default MetroWrapper;
